import { EPromoType, IPromoInfoSchema } from '../../../repositories/newbuilding-card/entities/promo/PromoInfoSchema';

export const getAuthorLabel = (promo: IPromoInfoSchema): string | null => {
  const isCianMortgage = promo.promoType === EPromoType.CianMortgage;

  if (isCianMortgage) {
    return null;
  }

  return promo.isFromBuilder ? 'Застройщик' : 'Представитель застройщика';
};
